import React,{Component}from 'react';
 import './Todoitem.css'
 import PropTypes from 'prop-types'

class Todoitem extends Component{

getStyle =()=>{
        return{
            textDecoration:this.props.todo.completed?
            'line-through':'none',
            // backgroundColor:'gray',
          
         
    }
}

render(){
 

  return (
      <div id="main">
          <div id="task" style={this.getStyle()}>
            <input onChange={this.props.ontoggle.bind(this, this.props.todo.id)} type="checkbox"/>{'   '}
            {this.props.todo.title}
          </div>
          <div id="btn">
            <button>Edit</button>
            <button onClick= {this.props.deltodo.bind(this, this.props.todo.id)} id="btnDelete" >Delete</button>
          </div>
          
     
      </div>
      
  )
}
}
Todoitem.propTypes ={
  todo:PropTypes.object.isRequired,
  ontoggle: PropTypes.func.isRequired,
  deltodo: PropTypes.func.isRequired
}
export default Todoitem;